import { createAction } from 'redux-actions';

export const loadAllCustomFields = createAction('LOAD_ALL_CUSTOM_FIELDS');
export const addCustomField = createAction('ADD_CUSTOM_FIELD');
export const addCustomFieldsToParent = createAction('ADD_CUSTOM_FIELDS_TO_PARENT');
export const updateCustomFields = createAction('UPDATE_CUSTOM_FIELDS');
export const updateCustomFieldParent = createAction('UPDATE_CUSTOM_FIELD_PARENT');
export const updateCustomFieldList = createAction('UPDATE_CUSTOM_FIELD_LIST');
export const removeCustomField = createAction('REMOVE_CUSTOM_FIELD');
